import { ClinicalItemType, InventoryPartType, ProvidedServiceType } from '@/api/apis/case';

export const serviceTypeNames: Record<ProvidedServiceType, string> = {
  [ProvidedServiceType.OCSManagement]: 'OCS Management',
  [ProvidedServiceType.OCSPerfusionSet]: 'OCS Perfusion Set',
  [ProvidedServiceType.SurgicalRetrieval]: 'Surgical Retrieval',
};

export const inventoryTypeNames: Record<InventoryPartType, string> = {
  [InventoryPartType.LiverPerfusionSet]: 'Liver Perfusion Set',
  [InventoryPartType.LiverBileSaltsSet]: 'Liver Bile Salts Set',
  [InventoryPartType.LiverGasCylinder80PercentOxygen]: 'Liver Gas Cylinder, 80 Percent Oxygen',
  [InventoryPartType.HeartPerfusionSet]: 'Heart Perfusion Set',
  [InventoryPartType.KidneyPerfusionSet]: 'Kidney Perfusion Set',
  [InventoryPartType.HeartSolutionSetRef1300]: 'Heart Solution Set, Ref 1300',
  [InventoryPartType.CableTieToolSmallDiameter]: 'Cable Tie Tool, Small Diameter',
  [InventoryPartType.GasCylinderEuUsCanada]: 'Gas Cylinder, EU, US, Canada',
  [InventoryPartType.LungPerfusionSet]: 'Lung Perfusion Set',
  [InventoryPartType.LungSolutionRef2300]: 'Lung Solution, Ref 2300',
  [InventoryPartType.GasCylinderM15A]: 'Gas Cylinder, M15A',
  [InventoryPartType.GasCylinderLu]: 'Gas Cylinder, Lu',
};

export const DANGER_EVENT_TYPES = [
  ClinicalItemType.RecordDelay,
  ClinicalItemType.DonorDidNotExpireInTime,
  ClinicalItemType.DryRun,
];
